import { ProgressMessage } from './data';

export const SOCURE_CONTAINER_ID = 'websdk';

export const Indicator = {
  LOADING: 'LOADING',
  WAITING_FOR_REDIRECT_METHOD: 'WAITING_FOR_REDIRECT_METHOD',
  WAITING_FOR_USER_TO_REDIRECT: 'WAITING_FOR_USER_TO_REDIRECT',
  WAITING_FOR_UPLOAD: 'WAITING_FOR_UPLOAD',
  DOCUMENTS_UPLOADED: 'DOCUMENTS_UPLOADED',
  VERIFYING: 'VERIFYING',
  VERIFICATION_COMPLETE: 'VERIFICATION_COMPLETE',
  VERIFICATION_ERROR: 'VERIFICATION_ERROR',
  RESUBMIT: 'resubmit',
  ERROR: 'ERROR',
};

export const progressMessage: ProgressMessage = {
  [Indicator.RESUBMIT]: {
    header: 'Something went wrong',
    firstSubheader: 'There was an issue verifying your photos.',
    secondSubheader: 'Please continue on your phone.',
  },
  [Indicator.ERROR]: {
    header: 'Something went wrong',
    firstSubheader: 'There was an error loading.',
    secondSubheader: 'Please try again.',
  },
  [Indicator.VERIFYING]: {
    header: 'Verify on your phone',
    firstSubheader: 'Thank you for submitting your photos!',
    secondSubheader: 'They are being uploaded and reviewed right now.',
  },
  [Indicator.WAITING_FOR_UPLOAD]: {
    header: 'Verify on your phone',
    firstSubheader: 'You’re currently verifying on your phone.',
    secondSubheader: 'Keep going!',
  },
  [Indicator.WAITING_FOR_USER_TO_REDIRECT]: {
    header: 'Verify on your phone',
    firstSubheader: 'Check your phone for a text message from us.',
    secondSubheader: 'Tap the link to begin taking photos of your ID and yourself.',
  },
  [Indicator.VERIFICATION_COMPLETE]: {
    header: 'Verify on your phone',
    firstSubheader: 'Verification Complete!',
  },
};
